import { render } from "./List.vue?vue&type=template&id=3d3c9af1&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=3d3c9af1&lang=scss"
import "./List.vue?vue&type=style&index=1&id=3d3c9af1&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3c9af1"]])

export default __exports__